import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import '../styles/SubscriptionPlans.css';

const SubscriptionPlans = ({ onPlanSelected }) => {
  const { user } = useAuth();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [subscription, setSubscription] = useState(null);
  
  useEffect(() => {
    // Obtener información de la suscripción actual
    const fetchSubscription = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/subscriptions/me', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setSubscription(response.data);
        
        // Ya no preseleccionamos automáticamente el plan para usuarios con suscripción personal
        // para evitar actualizaciones accidentales
      } catch (err) {
        console.error('Error al obtener la suscripción:', err);
      }
    };
    
    fetchSubscription();
  }, [onPlanSelected]);

  const handlePlanChange = (plan) => {
    setSelectedPlan(plan);
    if (onPlanSelected) {
      onPlanSelected(plan);
    }
  };

  return (
    <div className="subscription-plans-container">
      <h3 className="subscription-plans-title">
        {subscription?.type_subscript?.toLowerCase() === 'personal' ? 
          'Su plan Personal está por vencer. ¡Mejore a Plan Negocio Pro para acceder a más funcionalidades!' : 
          'El período de Prueba Gratuito esta por finalizar, seleccione el plan de su preferencia para continuar utilizando esta aplicación'}
      </h3>
      <div className="subscription-plans-cards">
        {/* Plan Personal - Solo mostrar si NO es un usuario con suscripción personal */}
        {subscription?.type_subscript?.toLowerCase() !== 'personal' && (
          <div className={`plan-card plan-personal ${selectedPlan === 'personal' ? 'selected' : ''}`}>
            <div className="plan-card-header">
              <h4 className="plan-card-title">Plan Básico Personal</h4>
              <div className="plan-card-price">Gratuito</div>
            </div>
            <ul className="plan-card-features">
              <li>Sólo Registro de Venta Rápida</li>
              <li>1 Punto de Venta</li>
              <li>Vendedor para el Punto de Venta</li>
              <li>Gráficas y Reportes Básicos</li>
            </ul>
            <div className="plan-selection">
              <input 
                type="radio" 
                id="plan-personal" 
                name="subscription-plan" 
                checked={selectedPlan === 'personal'} 
                onChange={() => handlePlanChange('personal')} 
              />
              <label htmlFor="plan-personal">Seleccionar Plan Básico Personal</label>
            </div>
          </div>
        )}

        {/* Plan Negocio - Siempre mostrar */}
        <div className={`plan-card plan-business ${selectedPlan === 'business' ? 'selected' : ''} ${subscription?.type_subscript?.toLowerCase() === 'personal' ? 'highlighted-plan' : ''}`}>
          <div className="plan-card-header">
            <h4 className="plan-card-title">Plan Negocio Pro</h4>
            <div className="plan-card-price">
              <span className="original-price">$149.00</span> 
              <span className="offer-price">$99.00 mxn mensuales</span>
              <div className="limited-offer">¡Oferta por tiempo limitado!</div>
            </div>
          </div>
          <ul className="plan-card-features">
            <li>Venta Rápida y Detallada</li>
            <li>Agrega más PdV por $99.00 mxn c/u</li>
            <li>Vendedores por Punto de Venta</li>
            <li>Gráficas y Reportes Avanzados por PdV</li>
          </ul>
          <div className="plan-selection">
            <input 
              type="radio" 
              id="plan-business" 
              name="subscription-plan" 
              checked={selectedPlan === 'business'} 
              onChange={() => handlePlanChange('business')} 
            />
            <label htmlFor="plan-business">Seleccionar Plan Negocio Pro</label>
          </div>
        </div>
      </div>
      <div className="update-subscription-button-container">
        <button 
          className={`update-subscription-button ${!selectedPlan ? 'disabled' : ''} ${loading ? 'loading' : ''}`}
          disabled={!selectedPlan || loading}
          onClick={async () => {
            try {
              setLoading(true);
              setError(null);
              console.log('Plan seleccionado:', selectedPlan);
              
              // Obtener el token de autenticación
              const token = localStorage.getItem('token');
              
              // Llamar al endpoint para actualizar el plan de suscripción
              await axios.put('/api/subscriptions/me/plan', 
                { plan: selectedPlan },
                { headers: { Authorization: `Bearer ${token}` }}
              );
              
              // Recargar la página para actualizar la información
              window.location.reload();
            } catch (err) {
              console.error('Error al actualizar el plan de suscripción:', err);
              setError('Ocurrió un error al actualizar el plan. Por favor, intente nuevamente.');
              setLoading(false);
            }
          }}
        >
          {loading ? 'Actualizando...' : 'Actualizar Plan de Suscripción'}
        </button>
        {!selectedPlan && <p className="select-plan-message">Seleccione un plan para continuar</p>}
        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default SubscriptionPlans;
